import { useState } from 'react';
import { usersApi } from '../api/users';
import { tiersApi, Tier } from '../api/tiers';

export interface UseTierManagerParams {
  selectedUserId: string | null;
  onTierChanged: (userId: string) => Promise<void>;
  onError: (msg: string) => void;
}

export function useTierManager({ selectedUserId, onTierChanged, onError }: UseTierManagerParams) {
  const [availableTiers, setAvailableTiers] = useState<Tier[]>([]);
  const [showTierDropdown, setShowTierDropdown] = useState(false);
  const [isChangingTier, setIsChangingTier] = useState(false);

  const loadTiers = async () => {
    try {
      const response = await tiersApi.list();
      setAvailableTiers(response.tiers);
    } catch (err) {
      console.error('Failed to load tiers:', err);
    }
  };

  const handleChangeTier = async (tierId: string) => {
    if (!selectedUserId) return;

    try {
      setIsChangingTier(true);
      await usersApi.update(selectedUserId, { tier_id: tierId });
      await onTierChanged(selectedUserId);
      setShowTierDropdown(false);
    } catch (err) {
      console.error('Failed to change tier:', err);
      onError('티어 변경에 실패했습니다.');
    } finally {
      setIsChangingTier(false);
    }
  };

  return {
    availableTiers,
    showTierDropdown,
    isChangingTier,
    setShowTierDropdown,
    loadTiers,
    handleChangeTier,
  };
}
